var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrioritize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08301 3.50004C4.08301 2.85571 4.60534 2.33337 5.24967 2.33337C5.89401 2.33337 6.41634 2.85571 6.41634 3.50004C6.41634 4.14437 5.89401 4.66671 5.24967 4.66671C4.60534 4.66671 4.08301 4.14437 4.08301 3.50004Z",
    fill: "#798B99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08301 7.00004C4.08301 6.35571 4.60534 5.83337 5.24967 5.83337C5.89401 5.83337 6.41634 6.35571 6.41634 7.00004C6.41634 7.64437 5.89401 8.16671 5.24967 8.16671C4.60534 8.16671 4.08301 7.64437 4.08301 7.00004Z",
    fill: "#798B99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08301 10.5C4.08301 9.85571 4.60534 9.33337 5.24967 9.33337C5.89401 9.33337 6.41634 9.85571 6.41634 10.5C6.41634 11.1444 5.89401 11.6667 5.24967 11.6667C4.60534 11.6667 4.08301 11.1444 4.08301 10.5Z",
    fill: "#798B99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58301 3.50004C7.58301 2.85571 8.10534 2.33337 8.74967 2.33337C9.39401 2.33337 9.91634 2.85571 9.91634 3.50004C9.91634 4.14437 9.39401 4.66671 8.74967 4.66671C8.10534 4.66671 7.58301 4.14437 7.58301 3.50004Z",
    fill: "#798B99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58301 7.00004C7.58301 6.35571 8.10534 5.83337 8.74967 5.83337C9.39401 5.83337 9.91634 6.35571 9.91634 7.00004C9.91634 7.64437 9.39401 8.16671 8.74967 8.16671C8.10534 8.16671 7.58301 7.64437 7.58301 7.00004Z",
    fill: "#798B99"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58301 10.5C7.58301 9.85571 8.10534 9.33337 8.74967 9.33337C9.39401 9.33337 9.91634 9.85571 9.91634 10.5C9.91634 11.1444 9.39401 11.6667 8.74967 11.6667C8.10534 11.6667 7.58301 11.1444 7.58301 10.5Z",
    fill: "#798B99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrioritize);
export default __webpack_public_path__ + "static/media/prioritize.6607c726ffa97369e27da8fce065f54a.svg";
export { ForwardRef as ReactComponent };